// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class PortfolioStatisticsRequest extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_PFIX_PORTFOLIO_STATISTICS_REQUEST, fieldSet);
    }
    setAccountId(accountId) {
        this.setFieldValue(FieldsFactory.FIELD_ACCOUNT_ID, accountId);
    }
    setType(type) {
        this.setFieldValue(FieldsFactory.FIELD_TYPE, type);
    }
    setStartTime(startTime) {
        if (startTime) {
            this.setFieldValue(FieldsFactory.FIELD_START_TIME, startTime);
        }
    }
    setEndTime(endTime) {
        if (endTime) {
            this.setFieldValue(FieldsFactory.FIELD_END_TIME, endTime);
        }
    }
    setRouteId(routeId) {
        if (routeId) {
            this.setFieldValue(FieldsFactory.FIELD_ROUTE_ID, routeId);
        }
    }
    setInstrumentTradableId(instrumentTradableId) {
        if (instrumentTradableId) {
            this.setFieldValue(FieldsFactory.FIELD_TRADABLE_INSTRUMENT_ID, instrumentTradableId);
        }
    }
}
